// JsFromRoutes CacheKey 39bb303c13664b05035c5924024ff16b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/storage/blobs/proxy/:signed_id/*filename'),
}
